import { BasicButton } from 'src/design/atoms/BasicButton';
import { IconArrowLeft } from '@tabler/icons-react';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Header } from 'src/design/organisms/Header';
import { useJobs } from 'src/hooks/useJobs';
import { TimesheetCard } from 'src/routes/Jobs/Timesheets/components/TimesheetCard';
import { tempOptions } from 'src/routes/Jobs/Timesheets/components/WeekSelector';
import { formatWorkWeekId } from 'src/utils/workWeek';

export const ViewTimesheet: React.FC = () => {
  const params: any = useParams();
  const navigate = useNavigate();
  const { team, selectedJob } = useJobs();

  const selectedWeek = React.useMemo(
    () =>
      tempOptions.find(
        (o) =>
          o.id === formatWorkWeekId(Number(params.year), Number(params.weekId)),
      ),
    [params.year, params.weekId],
  );

  const selectedTeamMember = React.useMemo(
    () => team.find((o) => o.userId === Number(params.userId)),
    [params.userId, team],
  );

  return (
    <>
      <Header
        title={`${selectedTeamMember?.user.fullName}`}
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            {
              text: 'Timesheets',
              href: `/jobs/${selectedJob?.id}/timesheets`,
            },
            { text: `Week ${params.weekId}, ${params.year}` },
            { text: `${selectedTeamMember?.user.fullName}` },
          ],
        }}
        helpText="View this team member's timesheet for the selected week."
        actions={
          <BasicButton
            onClick={() => navigate(`/jobs/${selectedJob?.id}/timesheets`)}
            leftSection={<IconArrowLeft size={16} />}
            variant="subtle"
          >
            Back
          </BasicButton>
        }
      />
      {selectedJob && (
        <TimesheetCard
          selectedJob={selectedJob}
          weekId={params.weekId}
          year={params.year}
          userId={params.userId}
          team={team}
        />
      )}
    </>
  );
};
